import { render, staticRenderFns } from "./ProductTianjin.vue?vue&type=template&id=75d48884&scoped=true&lang=pug"
import script from "./ProductTianjin.vue?vue&type=script&lang=js"
export * from "./ProductTianjin.vue?vue&type=script&lang=js"
import style0 from "./ProductTianjin.vue?vue&type=style&index=0&id=75d48884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d48884",
  null
  
)

export default component.exports